import React, { useEffect } from "react";
import { SemanticSearchStoreProvider } from "./SemanticSearchStoreProvider";
import { SemanticSearchView } from "./SemanticSearchView";
import { useSemanticSearchStore } from "./store/SemanticSearchContext";

interface SemanticSearchAppProps {
    chatGptEnabled: boolean;
}

const AppInitializer: React.FC<{ chatGptEnabled: boolean }> = ({ chatGptEnabled }) => {
    const setChatGptEnabled = useSemanticSearchStore(state => state.setChatGptEnabled);
    useEffect(() => {
        setChatGptEnabled(chatGptEnabled);
    }, [chatGptEnabled, setChatGptEnabled]);

    return <SemanticSearchView />;
};

export const SemanticSearchApp: React.FC<SemanticSearchAppProps> = ({ chatGptEnabled }) => {
    return (
        <SemanticSearchStoreProvider>
            <AppInitializer chatGptEnabled={chatGptEnabled} />
        </SemanticSearchStoreProvider>
    );
};